import React, { Component } from 'react';

import "./Home.scss";

export class Home extends Component {
  render() {
    return (
      <div>
        <h3>Welkom, {this.props.userName}!</h3>  
      </div>
    );
  }
}

export default Home;